import { message } from "antd";

export const handleAPIResponse = (res, callback) => {
  if (res?.status == "ERROR") {
    message.error(res.message);
  } else {
    callback();
  }
};
